export type AccountMenuStyle = 'Compact' | 'Expanded';
export const AccountMenuStyle = {
  Compact: 'Compact' as AccountMenuStyle,
  Expanded: 'Expanded' as AccountMenuStyle,
};
